import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  CascaderSelect,
  Message,
  Tag,
  Select,
  Card,
  Pagination,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import 'antd/dist/antd.css';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';
import Webcam from 'react-webcam';
import { Image } from 'antd';
import ezconImg from '../../../../../public/ezcon.png';
const VisitorStatisticsList = (props) => {
  const Option = Select.Option;
  const { RangePicker } = DatePicker;
  const currentDate = moment();
  const localeData = currentDate.clone().localeData(); //currentDate
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const cardManagement = client.service('cardManagement');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [visitorAppointmentAllArr, setVisitorAppointmentAllArr] = useState([]);
  const [reservationTimeStart, setReservationTimeStart] = useState('');
  const [reservationTimeEnd, setReservationTimeEnd] = useState('');
  const [visitorsName, setVisitorsName] = useState('');
  const [visitorsPhone, setVisitorsPhone] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); //戶號
  // const [intervieweeName, setIntervieweeName] = useState('');
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState(''); //取卡狀態
  const [visitorsStatus, setVisitorsStatus] = useState('預約中'); //訪客狀態
  const [searchVisitorsCardNumber, setSearchVisitorsCardNumber] = useState('');
  const [visitorDetailDialog, setVisitorDetailDialog] = useState(false);
  const [visitorDetailIndex, setVisitorDetailIndex] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [visitorPhoto, setVisitorPhoto] = useState(null);
  const [detailCardIndex, setDetailCardIndex] = useState('');
  const [cardStatus, setCardStatus] = useState(false);
  const [cardOrderNumber, setCardOrderNumber] = useState('');
  const [cardNumbering, setCardNumbering] = useState('');
  const [cardNotes, setCardNotes] = useState('');
  //搜尋
  // const [foundArr, setFoundArr] = useState(null);
  const [searchVisitorName, setSearchVisitorName] = useState('');
  const [searchHouseholdNumber, setSearchHouseholdNumber] = useState('');
  const [searchTimeStart, setSearchTimeStart] = useState('');
  const [searchTimeEnd, setSearchTimeEnd] = useState('');
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  // const [serachStatus, setSerachStatus] = useState(false);
  const [curdataIndex, setcurDataIndex] = useState('leaveTime');
  const [curorder, setcurOrder] = useState('asc');

  //card
  const [cardArr, setCardArr] = useState([]);
  // console.log(cardArr)
  //residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  //visitorArr

  async function funFindVisitor() {
    const result = await visitorAppointmentRegistration.find({
      query: {
        visitorsStatus: '已離場',
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funCreateVisitor(obj) {
    await visitorAppointmentRegistration.create(obj);
  }
  async function funUpdateVisitor(id, obj) {
    await visitorAppointmentRegistration.update(id, obj);
  }
  async function funRemoveVisitor(id) {
    await visitorAppointmentRegistration.remove(id);
  }

  const serverVisitorDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFindVisitor().then((result) => {
      setVisitorAppointmentArr(
        result.sort((a, b) => {
          const result = (typeof a[rdataIndex] === 'number'
            ? a[rdataIndex].toString()
            : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
      );
      setVisitorAppointmentAllArr(
        result.sort((a, b) => {
          const result = (typeof a[rdataIndex] === 'number'
            ? a[rdataIndex].toString()
            : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverVisitorDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);

  //card
  async function funFindCard() {
    const result = await cardManagement.find({
      query: {
        cardNumber: cardNumber,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCard(id, obj) {
    await cardManagement.update(id, obj);
  }

  function serverCardDataUpdate() {
    funFindCard().then((result) => {
      setCardArr(result);
    });
  }
  useEffect(() => {
    serverCardDataUpdate();
  }, [cardNumber]);

  //戶號選單
  function ParseStringToArrayObject() {
    //戶號拆解
    let data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    let newStages = {};
    Stages.forEach((e) => {
      //(e.length==1)newStages[e] = [e];
      if (e.indexOf('-') == -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        //newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    let FinalData = [];
    Object.keys(newStages).forEach((e) => {
      //{ A:['A','A-1'],B:['B','B-1','B-1-1']...}
      let childsObj = {};
      newStages[e].forEach((ee, nb) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childsObj[ee] = {
          //'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee, nb) => {
        //底層開始 => 加入到上一層children
        //if(ee.length>=3){
        if (ee.indexOf('-') != -1) {
          const tempArrChild = ee.split('-');
          //const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childsObj[ky].children) {
            //加入到上一層children
            childsObj[ky].children = [childsObj[ee]];
          } else {
            childsObj[ky].children.push(childsObj[ee]);
            childsObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); //label小－大
          }
        }
      });
      FinalData.push(childsObj[Object.keys(childsObj)[0]]); //只取最上層(第一比obj)(資料已經都加到第一比)
    });
    //console.log(FinalData);
    return FinalData;
  }
  // const dataSource = [];

  // for (let i = 0; i < residentAccountNumbersArr.length; i++) {
  //   //第一層
  //   let building = residentAccountNumbersArr[i].building;
  //   let objBuilding = dataSource.find((item) => item.label === building);
  //   if (!objBuilding) {
  //     objBuilding = {
  //       value: `${building}`,
  //       label: `${building}`,
  //       children: [],
  //     };
  //     dataSource.push(objBuilding);
  //   }
  //   //第二層
  //   let floor = residentAccountNumbersArr[i].floor;
  //   let objFloor = objBuilding.children.find((item) => item.label === floor);
  //   if (!objFloor) {
  //     objFloor = {
  //       value: `${building}-${floor}`,
  //       label: `${floor}`,
  //       children: [],
  //     };
  //     objBuilding.children.push(objFloor);
  //   }

  //   //第三層
  //   let floorChild = residentAccountNumbersArr[i].floorChild;
  //   let objFloorChild = dataSource.find((item) => item.label === floorChild);
  //   if (!objFloorChild) {
  //     objFloorChild = {
  //       value: `${building}-${floor}-${floorChild}`,
  //       label: `${floorChild}`,
  //     };
  //     objFloor.children.push(objFloorChild);
  //   }
  //   // console.log(`==${i}th dataSource:`,dataSource)
  // }

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = visitorAppointmentArr.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  return (
    <>
      <div className={styles.visitorSearchBox}>
        <h2>訪客名稱</h2>
        <Input
          hasClear={true}
          className={styles.visitorText}
          placeholder="請輸入訪客姓名"
          value={searchVisitorName}
          onChange={(value) => {
            setSearchVisitorName(value);
          }}
        />
        <h2 className={styles.visitorText}>受訪人戶號</h2>
        <CascaderSelect
          hasClear={true}
          className={styles.visitorText}
          placeholder="請選擇戶號"
          value={searchHouseholdNumber}
          dataSource={ParseStringToArrayObject()}
          onChange={(value) => {
            setSearchHouseholdNumber(value);
          }}
        ></CascaderSelect>

        <Button
          type="primary"
          className={styles.visitorText}
          onClick={() => {
            if (
              searchVisitorName &&
              searchHouseholdNumber &&
              dateStart &&
              dateEnd
            ) {
              let serachVisitorLeaveAll = visitorAppointmentAllArr.filter(
                (x) =>
                  x.visitorsName.match(
                    searchVisitorName.replace(
                      /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g,
                      ''
                    )
                  ) &&
                  x.householdNumber === searchHouseholdNumber &&
                  moment(x.leaveTime).isBetween(dateStart, dateEnd)
              );
              setVisitorAppointmentArr(serachVisitorLeaveAll);
            } else if (searchVisitorName && searchHouseholdNumber) {
              let serachVisitorLeave = visitorAppointmentAllArr.filter(
                (x) =>
                  x.visitorsName.match(
                    searchVisitorName.replace(
                      /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g,
                      ''
                    )
                  ) && x.householdNumber === searchHouseholdNumber
              );
              setVisitorAppointmentArr(serachVisitorLeave);
            } else if (searchHouseholdNumber && dateStart && dateEnd) {
              let serachVisitorLeave = visitorAppointmentAllArr.filter(
                (x) =>
                  x.householdNumber === searchHouseholdNumber &&
                  moment(x.leaveTime).isBetween(dateStart, dateEnd)
              );
              setVisitorAppointmentArr(serachVisitorLeave);
            } else if (searchVisitorName && dateStart && dateEnd) {
              let serachVisitorLeave = visitorAppointmentAllArr.filter(
                (x) =>
                  x.visitorsName === searchVisitorName &&
                  moment(x.leaveTime).isBetween(dateStart, dateEnd)
              );
              setVisitorAppointmentArr(serachVisitorLeave);
            } else if (searchVisitorName) {
              let serachVisitorLeaveSingle = visitorAppointmentAllArr.filter(
                (x) =>
                  x.visitorsName.match(
                    searchVisitorName.replace(
                      /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g,
                      ''
                    )
                  )
              );
              setVisitorAppointmentArr(serachVisitorLeaveSingle);
            } else if (searchHouseholdNumber) {
              let serachVisitorLeaveSingle = visitorAppointmentAllArr.filter(
                (x) => x.householdNumber === searchHouseholdNumber
              );
              setVisitorAppointmentArr(serachVisitorLeaveSingle);
            } else if (dateStart && dateEnd) {
              let serachVisitorLeaveSingle = visitorAppointmentAllArr.filter(
                (x) => moment(x.leaveTime).isBetween(dateStart, dateEnd)
              );
              setVisitorAppointmentArr(serachVisitorLeaveSingle);
            }
            Message.success('查詢成功');
          }}
        >
          搜尋
        </Button>
        <Button
          type="normal"
          className={styles.visitorText}
          onClick={() => {
            setSearchHouseholdNumber('');
            setSearchVisitorName('');
            setDateStart('');
            setDateEnd('');
            serverVisitorDataUpdate();
          }}
        >
          重置
        </Button>
      </div>
      <div className={styles.visitorSearchTimeBox}>
        <h2>日期</h2>
        <RangePicker
          // moment(dateEnd).subtract(1, 'days').format('YYYY-MM-DD')
          value={[dateStart, dateEnd]}
          className={styles.visitorTextTime}
          onChange={(value) => {
            // console.log(moment(value[1]).add(1, 'days').format('YYYY-MM-DD'))
            setDateStart(moment(value[0]).format('YYYY-MM-DD'));
            setDateEnd(moment(value[1]).add(1, 'days').format('YYYY-MM-DD'));
          }}
          onOk={(value) => {
            // if(value[0]===value[1]){
            //   Message.error("請務必選擇起始日期即結束日期")
            //   return;
            // }
          }}
        />
      </div>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorDetailDialog}
        footerActions={['ok']}
        onOk={() => {
          setVisitorDetailDialog(false);
        }}
        onCancel={() => {
          setVisitorDetailDialog(false);
        }}
        onClose={() => {
          setVisitorDetailDialog(false);
        }}
      >
        <h2>訪客資訊</h2>
        <div className={styles.detailPhoto}>
          <Form.Item className={styles.detailTitle} label="訪客姓名">
            {visitorsName}
          </Form.Item>
          {/* <img
            className={styles.photo}
            src={
              visitorPhoto
                ? visitorPhoto
                : ezconImg
            }
            alt="訪客照片"
          ></img> */}
          <Image
            className={styles.photo}
            src={visitorPhoto ? visitorPhoto : ezconImg}
            alt="訪客照片"
          />
        </div>
        <Form.Item className={styles.detailTitle} label="訪客電話">
          {visitorsPhone}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="人數">
          {peopleNumber}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="拜訪原因">
          {visitingReason}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="受訪人戶號">
          {householdNumber}
        </Form.Item>
        {/* <Form.Item className={styles.detailTitle} label="受訪人姓名">
                    {intervieweeName}
                  </Form.Item> */}
        <Form.Item className={styles.detailTitle} label="備註">
          {intervieweeRemarks}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="卡片流水號">
          {cardOrderNumber}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="卡片編號">
          {cardNumbering}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="卡片備註">
          {cardNotes}
        </Form.Item>
        {/* <Form.Item className={styles.detailTitle} label="訪客卡狀態">
                    {cardStatus === true ? "已還卡" : takeCardStatus}
                    {takeCardStatus === "遺失" ?
                      <Button
                        disabled={cardStatus === true ? true : false}
                        className={styles.detailTitleBtn}
                        type="secondary"
                        onClick={() => {


                          if (serachStatus === true) {
                            let cardItem = cardArr[0]
                            cardItem.cardStatus = '未使用';
                            let item = foundArr[visitorDetailIndex]
                            item.takeCardLost = '否';
                            item.takeCardStatus = '已還卡';
                            funUpdateVisitor(item._id, item).then(() => {
                              serverVisitorDataUpdate();

                            });
                            funUpdateCard(cardItem._id, cardItem).then(() => {
                              Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: '還卡成功',
                                showConfirmButton: false,
                                timer: 1500,
                              });
                              serverCardDataUpdate();


                            });
                          } else {
                            let cardItem = cardArr[0]
                            cardItem.cardStatus = '未使用';
                            let item = visitorAppointmentArr[visitorDetailIndex]
                            item.takeCardLost = '否';
                            item.takeCardStatus = '已還卡';
                            funUpdateVisitor(item._id, item).then(() => {
                              serverVisitorDataUpdate();
                            });
                            funUpdateCard(cardItem._id, cardItem).then(() => {
                              Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: '還卡成功',
                                showConfirmButton: false,
                                timer: 1500,
                              });
                              serverCardDataUpdate();

                            });
                          }
                          setCardStatus(true)

                        }}>

                        已還卡</Button> : ""}


                  </Form.Item> */}
      </Dialog>

      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}
            <Table.Column
              title="來訪時間"
              dataIndex="admissionTime"
              width={200}
              sortable
            />
            <Table.Column
              title="離開時間"
              dataIndex="leaveTime"
              width={200}
              sortable
            />
            <Table.Column
              title="卡片流水號"
              dataIndex="cardOrderNumber"
              width={150}
              sortable
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={100}
              sortable
            />
            <Table.Column
              title="受訪人戶號"
              dataIndex="householdNumber"
              width={150}
              sortable
            />
            <Table.Column
              title="拜訪原因"
              dataIndex="visitingReason"
              width={100}
              sortable
            />
            <Table.Column
              title="人數"
              dataIndex="peopleNumber"
              width={80}
              sortable
            />
            {/* <Table.Column
          title="訪客卡狀態"
          dataIndex="takeCardStatus"
          width={120}
        /> */}
            <Table.Column
              title="訪客狀態"
              dataIndex="visitorsStatus"
              width={100}
              sortable
            />
            {/* <Table.Column title="是否遺失訪客卡" dataIndex="takeCardLost" width={100} /> */}
            <Table.Column
              title="操作"
              width={150}
              lock="right"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setCardNumber(currentPosts[index].cardNumber);
                        setVisitorsName(currentPosts[index].visitorsName);
                        setVisitorsPhone(currentPosts[index].visitorsPhone);
                        setPeopleNumber(currentPosts[index].peopleNumber);
                        setVisitingReason(currentPosts[index].visitingReason);
                        setHouseholdNumber(currentPosts[index].householdNumber);
                        // setIntervieweeName(
                        //   currentPosts[index].intervieweeName
                        // );
                        setIntervieweeRemarks(
                          currentPosts[index].intervieweeRemarks
                        );
                        setVisitorPhoto(currentPosts[index].visitorPhoto);
                        setTakeCardStatus(currentPosts[index].takeCardStatus);
                        setCardOrderNumber(currentPosts[index].cardOrderNumber);
                        setCardNumbering(currentPosts[index].cardNumbering);
                        setCardNotes(currentPosts[index].cardNotes);
                        setVisitorDetailIndex(index);
                        setVisitorDetailDialog(true);
                      }}
                    >
                      詳細
                    </Button>
                  </div>
                );
              }}
            ></Table.Column>
          </Table>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default VisitorStatisticsList;
